export const US_HOSTNAME_SUFFIX = 'us.minna.tech';

//We use EU as fallback here, the original values for EU are,
//1. EU prod name = export const EU_PROD_HOSTNAME = 'action-portal.eu.minna.tech';
//2. Internal test environment suffix = export const INTERNAL_TEST_HOSTNAME_SUFFIX = '-action-portal.test.minna.io';
//3. External test environment suffix = export const EXTERNAL_TEST_HOSTNAME_SUFFIX = '-external-action-portal.minna.io';
//4. Preprod hostname = export const PREPROD_HOSTNAME = 'pre-prod-europe-action-portal.minna.io';
